// Application constants
export const CONFIG = {
  ACCESS_CODE: 'sommar2025',
  SWISH_PHONE: '0706769888',
  SWISH_MESSAGE: 'Leksandssläktet',
  ELECTRICITY_RATE: 1.5, // kr per kWh
  NIGHT_COST: 150 // kr per night
};

// API base origin pointing to Cloudflare Pages Functions
export const API_BASE = '/api';

export const API_ENDPOINTS = {
  LOGIN: '/api/login',
  FAMILIES: '/api/families', 
  BOOKINGS: '/api/bookings'
};

export const MESSAGES = {
  LOGIN_SUCCESS: 'Inloggning lyckades!',
  LOGIN_FAILED: 'Fel kod. Försök igen!',
  BOOKING_SUCCESS: 'Bokning sparad!',
  BOOKING_FAILED: 'Något gick fel vid bokning',
  PAYMENT_SUCCESS: 'Betalning registrerad!',
  PAYMENT_FAILED: 'Något gick fel vid betalning'
};
